import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";

export const getAllNationalities = createAsyncThunk(
  "Nationality/FindAllNationality",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Nationality/FindAllNationality`,
        {
          Nationality: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Nationalities:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createNationality = createAsyncThunk(
  "Nationality/InsertNationality",
  async (NationalityData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Nationality/InsertNationality`,
        NationalityData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating nationality:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateNationality = createAsyncThunk(
  "Nationality/UpdateNationality",
  async (NationalityData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Nationality/UpdateNationality`,
        NationalityData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating nationality:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteNationality = createAsyncThunk(
  "Nationality/DeleteNationality",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Nationality/DeleteNationality`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting nationality:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getNationalityByID = createAsyncThunk(
  "Nationality/FindByIDNationality",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Nationality/FindByIDNationality`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Nationality: result.Nationality,
        IsActive: result?.IsActive ? 1 : 2,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching nationalities:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveNationality = createAsyncThunk(
  "Nationality/ActiveInActiveNationality",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Nationality/ActiveInActiveNationality`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive nationality:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveNationalities = createAsyncThunk(
  "Nationality/FindAllActiveNationality",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Nationality/FindAllActiveNationality`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching nationalities:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
